// extracted by mini-css-extract-plugin
export default {"main":"HorizontalSocialLinksPanel_main__fRVy6","title":"HorizontalSocialLinksPanel_title__06ENT","items":"HorizontalSocialLinksPanel_items__japfu"};